import codeofafricaLogo from '../assets/customers/codeofafrica.svg';
import gizLogo from '../assets/customers/giz.png';
import strathmoreLogo from '../assets/customers/strathmore.png';

import type { Customer } from './types/customer';

export const customers: Customer[] = [
  {
    id: 'giz',
    name: 'Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH',
    logo: gizLogo,
    url: 'https://www.giz.de/en/html/index.html',
  },
  {
    id: 'code-of-africa',
    name: 'Code of Africa',
    logo: codeofafricaLogo,
    url: 'https://www.codeofafrica.com/',
  },
  {
    id: 'strathmore',
    name: 'Strathmore University',
    logo: strathmoreLogo,
    url: 'https://www.strathmore.edu/',
  },
];
